import { CircularProgress, Tooltip } from "@material-ui/core";
import {
  NewTemplateSurveyAction,
  RowActionsContainer,
} from "./styles";
import { useState } from "react";
import { toast } from "react-toastify";
import { producaov2 } from "../../../../../services/apis";

export default function SurveyTemplateRowActions({ surveyTemplateID }) {
  const [loadingCreation, setLoadingCreation] = useState(false);

  const handleCreate = async () => {
    setLoadingCreation(true);

    try {
      const response = await producaov2.post(
        `/admin/survey/template/${surveyTemplateID}`,
        {},
        {
          headers: {
            access_token: `voitto-token ${localStorage.getItem("oauth_token")}`,
          },
        }
      );

      window.open(`/admin/pesquisa/${response.data.id}`, '_self');
    } catch (error) {
      toast.error(
        `Houve um erro ao criar a pesquisa: ${
          error?.response?.data?.message || error?.message
        }`
      );
      setLoadingCreation(false);
    }
  };

  return (
    <RowActionsContainer>
      <Tooltip title="Criar nova pesquisa a partir desse modelo">
        <NewTemplateSurveyAction disabled={loadingCreation} onClick={handleCreate}>
          {loadingCreation ? (
            <>
              Criando <CircularProgress size={14} />
            </>
          ) : (
            "Nova pesquisa"
          )}
        </NewTemplateSurveyAction>
      </Tooltip>
    </RowActionsContainer>
  );
}
